import { useInitData, useScreen } from '../../../../hooks'
import { useWidgetListOrder } from '../../../Widget'
import { useRequestProfileContext } from '../../RequestProfile.hooks'

import {
  REQUEST_PROFILE_DEFAULT_WIDGET_LIST_ORDER,
  REQUEST_PROFILE_WIDGET_LIST_PAGE,
} from './RequestProfileWidgetList.constants'
import {
  getRequestProfileOrderedWidgets,
  getRequestProfileWidgetsByKey,
} from './RequestProfileWidgetList.utils'
import { RequestProfileWidgetListColumns } from './RequestProfileWidgetListColumns'

function RequestProfileWidgetList() {
  const {
    isInitiated,
    isPreview,
    outboundUuid,
    requestData,
    requestProvidersPermissions,
  } = useRequestProfileContext()

  const { isMobileScreenSize } = useScreen()

  const isHeaderGroupLayout = isPreview || isMobileScreenSize

  const { ai_features: aiFeatures } = useInitData()

  const { isOrderResolved, widgetListOrder } = useWidgetListOrder({
    defaultOrder: REQUEST_PROFILE_DEFAULT_WIDGET_LIST_ORDER,
    page: REQUEST_PROFILE_WIDGET_LIST_PAGE,
  })

  const isSkeleton = !isInitiated || !requestData || !isOrderResolved

  const widgetsByKey = getRequestProfileWidgetsByKey({
    aiFeatures,
    isHeaderGroupLayout,
    isSkeleton,
    outboundUuid,
    requestData,
    requestProvidersPermissions,
  })

  const widgets = getRequestProfileOrderedWidgets({
    widgetListOrder,
    widgetsByKey,
  })

  if (!isHeaderGroupLayout) {
    return widgets
  }

  return <RequestProfileWidgetListColumns widgets={widgets} />
}

export default RequestProfileWidgetList
